import React, { useState, ReactNode } from 'react';
import ChevronUpIcon from '@atlaskit/icon/glyph/chevron-up';
import ChevronDownIcon from '@atlaskit/icon/glyph/chevron-down';
import './collapsible-summary-grid.scss';

interface CollapsibleSummaryGridProps {
  title: string;
  data: Array<{ label: ReactNode; value: ReactNode }>;
}

export const CollapsibleSummaryGrid = ({ title, data }: CollapsibleSummaryGridProps) => {
  const [isExpanded, setIsExpanded] = useState(true);
  return (
    <div className="collapsible-summary-grid">
      <div
        className={`summary-header ${isExpanded ? 'expanded' : 'collapsed'}`}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="title">{title}</div>
        {isExpanded ? <ChevronUpIcon label="Collapse Icon" /> : <ChevronDownIcon label="Expand icon" />}
      </div>
      {isExpanded && (
        <div className="summary-fields">
          {data.map((fieldDetail, idx) => {
            return (
              <div className="row" key={idx}>
                <div className="row-title">{fieldDetail.label}</div>
                <div className="row-value">{fieldDetail.value}</div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
